import React, { useEffect, useState } from "react";
import { Button, List, Space, Switch, Tag, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { getUserInfo } from "../../utils/redux/reducers/User";
import ApiManager from "../../utils/api/ApiManager";

const i18n = Locale.getInstance();
const api = ApiManager.getInstance().groupon;

function DealList() {
  const user = useSelector((state) => getUserInfo(state));
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ data: [] });

  const load = async (page = 1) => {
    if (!user.token) return;
    setLoading(true);
    try {
      const res = await api.productList.run({
        token: user.token,
        query: { page, count: 20 },
      });
      if (res.result) {
        setData(res.data);
      } else {
        message.warning(res.message);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onDelete = async (id) => {
    try {
      const res = await api.productDelete.run({ token: user.token, path: { id } });
      if (res.result) {
        message.success(res.message || i18n.t("groupon.delete"));
        load();
      } else {
        message.warning(res.message);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Space style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push("/main/groupon/deals/edit", { item: null })}
        >
          {i18n.t("groupon.addDeal")}
        </Button>
      </Space>
      <List
        loading={loading}
        dataSource={data.data || []}
        pagination={{
          current: data.current_page,
          total: data.total,
          pageSize: data.per_page || 20,
          onChange: load,
        }}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                type="link"
                onClick={() =>
                  history.push("/main/groupon/deals/edit", { item })
                }
              >
                {i18n.t("groupon.edit")}
              </Button>,
              <Button type="link" danger onClick={() => onDelete(item.id)}>
                {i18n.t("groupon.delete")}
              </Button>,
            ]}
          >
            <List.Item.Meta
              title={
                <Space>
                  <Tag>{i18n.getPropNameByLocale(item)}</Tag>
                  <Switch checked={item.status === 1} disabled size="small" />
                </Space>
              }
              description={
                <Space size={4}>
                  {item.original_price > item.price && (
                    <span style={{ textDecoration: "line-through", color: "#999" }}>
                      ¥{(item.original_price / 100).toFixed(2)}
                    </span>
                  )}
                  <span>¥{(item.price / 100).toFixed(2)}</span>
                  <span>
                    / {item.needed_points}
                    {i18n.t("groupon.points")}
                  </span>
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
}

export default DealList;
